import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GoToTop } from './../../Commons/GoToTop'
import { APP_VERSION } from './../../../version'
import { useAuth } from '../../Providers/AuthProvider'


const SecondaryBase = ({ children, actionToExecute = null, classNameApplied, urlToGo = null }) => {
    const navigate = useNavigate()
    const { logout } = useAuth()


    const ActionToExecute = () => {
        try {
            actionToExecute()
        } catch (error) {
            
        }
    }

    const Logout = async () => {
        try {
            await logout()
        } catch (error) {
            navigate('/login')
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            <header className={`Header__Secondary container ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {classNameApplied && classNameApplied !== '' ? (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--WhiteOutlineTransparent' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                ) : (
                    <button type='button' className='Header__Secondary__Buttons Btn__Adsl--RedOutline' onClick={Logout}>
                        <i className="bi bi-box-arrow-right"></i>
                    </button>
                )}
            </header>

            <main className={`container Dashboard Container-FullHeight ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                <div className="ReturnButton">
                    {classNameApplied && classNameApplied !== '' ? (
                        urlToGo && urlToGo !== '' ? (
                            <button className='ReturnButton__Button__White' onClick={() => navigate(urlToGo)}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        ) : (
                            <button className='ReturnButton__Button__White' onClick={() => ActionToExecute()}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        )
                    ) : (
                        urlToGo && urlToGo !== '' ? (
                            <button className='ReturnButton__Button' onClick={() => navigate(urlToGo)}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        ) : (
                            <button className='ReturnButton__Button' onClick={() => ActionToExecute()}>
                                <i className="bi bi-arrow-90deg-left fs-5"></i>
                            </button>
                        )
                    )}
                </div>

                <div className="row mt-3">
                    {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                    <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

                    <div className="mt-5">
                        {children}
                    </div>
                </div>
            </main>

            <GoToTop />

            <footer className={`container ${classNameApplied && classNameApplied !== '' ? classNameApplied : ''}`}>
                {classNameApplied && classNameApplied !== '' ? (
                    <>
                        <p className='text-center text-white FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
                        <p className='text-center text-white-50 small mt-1' style={{ fontSize: '9px', opacity: 0.5, margin: 0 }}>
                            v{APP_VERSION}
                        </p>
                    </>
                ) : (
                    <>
                        <p className='text-center FooterCredits' style={{ backgroundColor: '#fff', borderRadius: '12px' }}>
                            <a href='https://interaktia.com/?utm_source=lightshow_web&utm_medium=footer&utm_campaign=fdm_spinsmx_s2' style={{ color: '#000' }}>Hecho con ♥ por Interaktia | 2026</a>
                        </p>
                        <p className='text-center text-muted small mt-1' style={{ fontSize: '9px', opacity: 0.5, margin: 0 }}>
                            v{APP_VERSION}
                        </p>
                    </>
                )}
            </footer>
        </>
    )
}

export { SecondaryBase };